module.exports = __webpack_public_path__ + "static/img/zdhf06.df48a1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zdhf06.png
// module id = 123
// module chunks = 0